import React, { useState, useCallback, MouseEvent } from 'react';

import Grid from '@material-ui/core/Grid';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import EditGrupoSimples from '../Drawers/Grupos/Edit/EditGrupoSimples';
import NewProdutoSimples from '../Drawers/Produtos/NewProdutoSimples';

import DeleteGrupo from './DeleteGrupo';

import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';

import { StatusSaleButton, AccordionTitle, ButtonsWrapper } from '../styles';
import styles from '../styles/material_styles';

interface SummaryGrupoSimplesProps {
  grupo_id: number;
  descricao: string;
  pausar_venda: boolean;
  tipo_produto: number;
  imagem: string;
}

const ITEM_HEIGHT = 48;

const SummaryGrupoSimples: React.FC<SummaryGrupoSimplesProps> = ({
  grupo_id,
  descricao,
  pausar_venda,
  tipo_produto,
  imagem,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [vendaPausada, setVendaPausada] = useState(pausar_venda);

  const open = Boolean(anchorEl);
  const classes = styles();

  const { addToast } = useToast();

  const handleSetPausedGroup = useCallback(
    async (value: boolean) => {
      try {
        api
          .put(`/grupo/${grupo_id}`, { pausar_venda: value })
          .then((response) => {
            const { pausar_venda } = response.data;
            setVendaPausada(pausar_venda);

            addToast({
              type: 'info',
              title: `Grupo ${descricao} ${
                pausar_venda ? 'desativado' : 'ativado'
              }.`,
            });
          });
      } catch (err) {
        const { message } = err.response.data;

        addToast({
          type: 'error',
          title: message,
        });
      }
    },
    [grupo_id, addToast, descricao],
  );

  const handleClick = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel-content"
      id="panel-header"
      className={classes.accordionSummary}
    >
      <Grid container>
        <Grid item lg={4} md={4} xs={6}>
          <AccordionTitle>
            <div
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
            >
              <IconButton
                aria-label="more"
                aria-controls="options-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="options-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}
              >
                <MenuItem onClick={handleClose}>
                  <EditGrupoSimples
                    grupo_id={grupo_id}
                    descricao={descricao}
                    imagem={imagem}
                  />
                </MenuItem>

                <MenuItem onClick={handleClose}>
                  <DeleteGrupo grupo_id={grupo_id} descricao={descricao} />
                </MenuItem>
              </Menu>
            </div>

            <div>
              <h1>{descricao}</h1>
            </div>
          </AccordionTitle>
        </Grid>

        <Grid item lg={4} md={4} xs={6}>
          <NewProdutoSimples
            grupo_id={grupo_id}
            grupo_descricao={descricao}
            tipo_produto={tipo_produto}
          />
        </Grid>

        <Grid item lg={4} md={4}>
          <ButtonsWrapper>
            <div
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
            >
              <StatusSaleButton
                type="button"
                isPaused={!vendaPausada}
                className="paused"
                onClick={() => handleSetPausedGroup(true)}
              >
                Pausado
              </StatusSaleButton>

              <StatusSaleButton
                type="button"
                isPaused={vendaPausada}
                className="activated"
                onClick={() => handleSetPausedGroup(false)}
              >
                Ativado
              </StatusSaleButton>
            </div>
          </ButtonsWrapper>
        </Grid>
      </Grid>
    </AccordionSummary>
  );
};

export default SummaryGrupoSimples;
